import React from "react";

const palette = {
  approved: "bg-emerald-100 text-emerald-700",
  pending: "bg-amber-100 text-amber-700",
  rejected: "bg-rose-100 text-rose-700",
};

const StatusBadge = ({ status = "pending" }) => {
  return (
    <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold capitalize ${palette[status] || palette.pending}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
